<template>
  <div class="login">
    <div class="login-header" style="padding-right: 20px;">
      <div class="goBack" @click="goToBack()"><i class="el-icon-back"></i></div>
      <el-row type="flex" justify="center" align="center">
        <el-col :xs="24">
          <div class="headerMain">

            <div style="display:flex;align-items: center;">
              <img src="@/assets/img/logo.jpg" alt="logo" style="width: 60px ;height:60px;" />
              <div class="headerTop">北京市人事考试视频指挥调度一体化平台</div>

              <!-- 下拉菜单 -->
              <div class="dropdown-menu" @click="toggleDropdown">
                <svg-icon icon="arrow" class="dropdown-arrow" :class="{ 'arrow-up': dropdownVisible }" />
                <div v-if="dropdownVisible" class="dropdown-content" @click.stop>
                  <div class="dropdown-item" @click="goToPlatform">
                    朝阳区人事考试智能指挥调度一体化平台
                  </div>
                </div>
              </div>

            </div>
            <div>
              <el-select style="width: 400px;" v-model="examId" placeholder="请选择考试" clearable @change="changeExam"
                size="small">
                <el-option v-for="item in examOptions" :key="item.id" :label="item.examName" :value="item.id">
                </el-option>
              </el-select>
              <el-button class="changeBtn" size="small" type="primary" @click="goLocationTracePage()">地图轨迹</el-button>
              <el-button class="changeBtn" size="small" type="primary" @click="goVideoPage()">考试视频</el-button>
            </div>


            <!-- <img class="login-header-logo" src="@/assets/img/login-logo.png" alt="logo" /> -->
            <div class="headerRight" style="display:none;">
              <div class="curUserInfo" v-if="curShow">当前登录用户：{{ currentUserId }}</div>
              <el-input v-model="thirdPartyId" placeholder="请输入" class="changeNums" clearable
                oninput="value=value.replace(/[^\d]/g,'')"></el-input>
              <el-button class="changeBtn" size="small" type="primary" plain @click="idChange">切换用户</el-button>
              <!-- <el-button class="changeBtn" size="small" type="primary" plain @click="goToBj">北京市</el-button> -->
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="loginContainer">
      <div class="leftMap" id="mapContainer">

      </div>
      <div class="rightMsg">

      </div>
    </div>
    <!-- <div class="login-container">
      <div class="login-content">
        <div class="login-title">加入会议</div>
        <el-form
          :model="loginForm"
          status-icon
          :rules="rules"
          :label-position="labelPosition"
          ref="loginForm"
          class="login-form"
        >
          <el-form-item
            v-if="isThird"
            prop="extUserId"
            :rules="{
              required: true,
              message: '请输入第三方用户ID',
              trigger: 'blur',
            }"
          >
            <el-input v-model="loginForm.extUserId" autocomplete="off" placeholder="第三方用户ID"></el-input>
          </el-form-item>

          <el-form-item
            v-if="!isThird"
            prop="phone"
            :rules="{
              required: true,
              message: '请输入小鱼账号',
              trigger: 'blur',
            }"
          >
            <el-input v-model="loginForm.phone" autocomplete="off" placeholder="输入小鱼账号"></el-input>
          </el-form-item>

          <el-form-item
            v-if="!isThird"
            prop="password"
            :rules="{
              required: true,
              message: '请输入账号密码',
              trigger: 'blur',
            }"
          >
            <el-input
              type="password"
              v-model="loginForm.password"
              autocomplete="off"
              placeholder="输入账号密码"
            ></el-input>
          </el-form-item>

          <el-form-item prop="meeting">
            <el-input v-model="loginForm.meeting" autocomplete="off" placeholder="输入云会议室号或终端号"></el-input>
          </el-form-item>

          <el-form-item prop="meetingPassword">
            <el-input
              type="password"
              v-model="loginForm.meetingPassword"
              autocomplete="off"
              placeholder="入会密码"
            ></el-input>
          </el-form-item>

          <el-form-item prop="meetingName">
            <el-input v-model="loginForm.meetingName" autocomplete="off" placeholder="输入会议中显示的名称"></el-input>
          </el-form-item>

          <el-button class="join-btn" type="primary" @click="submitForm('loginForm')">加入会议</el-button>
          <el-form-item class="login-form-checkbox">
            <el-checkbox v-model="loginForm.muteVideo">入会时关闭摄像头</el-checkbox>
          </el-form-item>
          <el-form-item class="login-form-checkbox">
            <el-checkbox v-model="loginForm.muteAudio">入会时静音</el-checkbox>
          </el-form-item>
        </el-form>
        <div class="setting-btn">
          <span @click="onOpenSetting"> 设置 <i class="el-icon-setting"></i> </span>
        </div>
      </div>
    </div> -->

    <el-drawer :title="drawerTitle" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
      size="400px">
      <div class="testCenter">
        <div class="timer">{{ currentTimeCur }} {{ currentTime }}</div>
        <!-- <div class="numBox">
          <p v-if="testCenterInfo.examPlaceType == '市指挥调度中心'"><span class="s_1">考区数量：</span><span class="s_2">{{
            testCenterInfo.examDistrictNum }}</span></p>
          <p v-if="testCenterInfo.examPlaceType == '市指挥调度中心' || testCenterInfo.examPlaceType == '区指挥调度中心'"><span
              class="s_1">考点数量：</span><span class="s_2">{{ testCenterInfo.examPlaceNum }}</span></p>
          <p><span class="s_1">考场数量：</span><span class="s_2">{{ testCenterInfo.examinationRoomNum }}</span></p>
        </div> -->
        <div class="numBox" style="margin-top: -10px;font-size: 16px;line-height: 28px;border:none;">
          <!-- <p><span class="s_1" style="font-size: 16px;">考区数量：</span><span class="s_2" style="font-size: 16px;">{{
            examDataInfo.examDistrictNum }}</span></p> -->
          <p><span class="s_1" style="font-size: 16px;">考点数量：</span><span class="s_2" style="font-size: 16px;">{{
            examDataInfo.examPlaceNum }}</span></p>
          <p><span class="s_1" style="font-size: 16px;">考场数量：</span><span class="s_2" style="font-size: 16px;">{{
            examDataInfo.examinationRoomNum }}</span></p>
        </div>

        <div v-if="testCenterInfo.meetingId" style="margin-bottom: 14px;">
          <div class="joinBtn" v-if="testCenterInfo.examPlaceType == '市指挥调度中心'" @click="joinConference(testCenterInfo)">
            进入指挥调度</div>
          <div class="joinBtn" v-if="testCenterInfo.examPlaceType == '区指挥调度中心'" @click="joinConference(testCenterInfo)">
            进入指挥调度</div>
          <div class="joinBtn" v-if="testCenterInfo.examPlaceType == '考点'" @click="joinConference(testCenterInfo)">监控回传
          </div>
        </div>

        <hr style="color: #E6E6E6;">

        <!-- <ul class="tc_Msg">
          <li>
            <img src="../../../assets/addImg/icon01.png" />
            <span class="s_1">考场数量：</span>
            <span class="s_2">{{ testCenterInfo.examinationRoomNum }}</span>
          </li>
          <li>
            <img src="../../../assets/addImg/icon02.png" />
            <span class="s_1">技术支持人员：</span>
            <span class="s_2">{{ testCenterInfo.technicalSupportName }}</span>
          </li>
          <li>
            <img src="../../../assets/addImg/icon03.png" />
            <span class="s_1">联系方式：</span>
            <span class="s_2">{{ testCenterInfo.technicalSupportTel }}</span>
          </li>
        </ul> -->
        <div class="examinationInfo" style="padding-bottom: 10px;">
          <div class="title_01">考试信息</div>
          <div class="infoLine" v-for="(item, index) in examDataInfo.examList" :key="index + 'a'">

            <div class="title_02">
              <span>{{ item.examName }}</span>
            </div>

            <div class="numBox"
              style="margin-top: -20px;font-size: 16px;line-height: 28px;border-bottom: none;padding: 10px 0;">
              <p><span class="s_1" style="font-size: 16px;">考区数量：</span><span class="s_2" style="font-size: 16px;">{{
                item.examDistrictNum }}</span></p>
              <p><span class="s_1" style="font-size: 16px;">考点数量：</span><span class="s_2" style="font-size: 16px;">{{
                item.examPlaceNum }}</span></p>
              <p><span class="s_1" style="font-size: 16px;">考场数量：</span><span class="s_2" style="font-size: 16px;">{{
                item.examinationRoomNum }}</span></p>
            </div>

            <div v-for="(item1, index) in item.groupList" :key="index + 'b'"
              style="font-size: 16px;color: #676767;line-height: 28px;">

              <div>
                <div><img src="../../../assets/addImg/icon04.png" />
                  <span style="position:relative;top: 2px;left: 4px;">{{ item1.examDate }}</span>
                </div>
                <div v-for="(item2, index) in item1.dataList" :key="index + 'b'">
                  <span>{{ item2.examStartTime }}~{{ item2.examEndTime }}</span>&nbsp;&nbsp;
                  <span>{{ item2.examSubject }}</span>
                </div>
              </div>

            </div>

            <div style="margin: 10px 0;" v-if="item.meetingId">
              <div class="joinBtn" v-if="testCenterInfo.examPlaceType == '市指挥调度中心'" @click="joinConference(item)">进入指挥调度
              </div>
              <div class="joinBtn" v-if="testCenterInfo.examPlaceType == '区指挥调度中心'" @click="joinConference(item)">进入指挥调度
              </div>
              <div class="joinBtn" v-if="testCenterInfo.examPlaceType == '考点'" @click="joinConference(item)">监控回传</div>
            </div>



          </div>
        </div>
        <!-- <div>
          <div class="joinBtn" :class="!testCenterInfo.meetingId ? 'joinBtnTwo' : ''"
            v-if="testCenterInfo.examPlaceType == '市指挥调度中心'" @click="joinConference(testCenterInfo)">进入指挥调度</div>
          <div class="joinBtn" :class="!testCenterInfo.meetingId ? 'joinBtnTwo' : ''"
            v-if="testCenterInfo.examPlaceType == '区指挥调度中心'" @click="joinConference(testCenterInfo)">进入指挥调度</div>
          <div class="joinBtn" :class="!testCenterInfo.meetingId ? 'joinBtnTwo' : ''"
            v-if="testCenterInfo.examPlaceType == '考点'" @click="joinConference(testCenterInfo)">监控回传</div>
        </div> -->
      </div>
    </el-drawer>
  </div>
</template>
<script>
import store from '@/utils/store';
import xyRTC from '@xylink/xy-rtc-sdk';
import axios from 'axios';
import { getExamDataList, getExamPlaceList, getExaminationPlaceList, getExaminationPlaceById, getExaminationDataList, getAllExamList } from "@/http/api/common";

export default {
  props: ['user', 'isThird'],
  computed: {
    currentTimeCur() {
      return this.formatDateTime(this.currentDate);
    }
  },
  data() {
    return {
      dropdownVisible: false, // 下拉菜单显示状态
      examDataInfo: {
        examDistrictNum: '',
        examPlaceNum: '',
        examinationRoomNum: '',
        examList: []
      },
      drawerTitle: '',
      markers: [], // 存储地图上的所有 marker
      MAP: null,
      examId: '',
      examOptions: [],
      curShow: false, // 是否显示当前登录用户
      currentUserId: '', // 当前登录用户
      thirdPartyId: '', // 切换第三方ID
      currentTime: new Date().toLocaleTimeString(), // 获取当前时分秒
      currentDate: new Date(), // 获取当前日期
      examinationDataList: [], // 考试列表
      pointsList: [], // 考点列表
      testCenterInfo: {}, // 考点信息对象
      drawer: false, // 弹窗
      direction: 'rtl', // 弹窗右侧打开
      MAP: null, // 地图
      xyRTC,
      labelPosition: 'right',
      loginForm: this.user,
      rules: {
        meeting: [{ required: true, message: '请输入会议号', trigger: 'blur' }],
        meetingPassword: [{ trigger: 'blur' }],
        meetingName: [{ required: true, message: '请输入入会昵称', trigger: 'blur' }],
      },
      isBjShow: false, // 是否定位北京
    };
  },
  created() {
    setInterval(() => {
      this.currentTime = new Date().toLocaleTimeString();
    }, 1000);
    let curId = sessionStorage.getItem("thirdPartyId");
    if (curId) {
      this.curShow = true;
      this.currentUserId = curId;
    }
  },
  mounted() {
    // this.getExaminationDataList();
    // this.getExaminationPlaceList();

    // 添加全局点击事件监听器
    document.addEventListener('click', this.handleClickOutside);

    getAllExamList().then(res => {
      if (res.data && res.data.length > 0) {
        this.examOptions = res.data;

        let data = {
          examIdList: []
        }
        res.data.forEach(item => {
          data.examIdList.push(item.id)
        })
        console.log('data:', data)
        getExamPlaceList(data).then(res => {
          if (res.data && res.data.length > 0) {
            this.pointsList = res.data;
            this.mapInit();
          } else {
            this.pointsList = [];
          }
        })
      } else {
        this.examOptions = [];
      }
    })
  },
  beforeDestroy() {
    // 移除全局点击事件监听器
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    updateMarkers(map, points) {
      // 清除已有的所有标记
      if (this.markers && this.markers.length > 0) {
        this.markers.forEach(marker => marker.setMap(null));
        this.markers = [];
      }

      // 创建图标
      const icon01 = new AMap.Icon({
        size: new AMap.Size(46, 46),
        image: require("../../../assets/addImg/pointsIcon01.png"),
        imageSize: new AMap.Size(46, 46),
        imageOffset: new AMap.Pixel(0, 0)
      });

      const icon02 = new AMap.Icon({
        size: new AMap.Size(26, 30),
        image: require("../../../assets/addImg/pointsIcon03.png"),
        imageSize: new AMap.Size(26, 30),
        imageOffset: new AMap.Pixel(0, 0)
      });

      const icon03 = new AMap.Icon({
        size: new AMap.Size(26, 31),
        image: require("../../../assets/addImg/pointsIcon02.png"),
        imageSize: new AMap.Size(26, 31),
        imageOffset: new AMap.Pixel(0, 0)
      });

      // 添加新标记
      for (let i = 0; i < points.length; i++) {
        const point = points[i];
        let icons = null;

        if (point.examPlaceType === '市指挥调度中心') {
          icons = icon01;
        } else if (point.examPlaceType === '区指挥调度中心') {
          icons = icon02;
        } else if (point.examPlaceType === '考点') {
          icons = icon03;
        }

        const marker = new AMap.Marker({
          position: [point.longitude, point.latitude],
          icon: icons,
        });

        marker.setLabel({
          direction: 'center',
          offset: new AMap.Pixel(0, -30),
          content: point.examPlaceName,
        });

        marker.on('click', (e) => {
          console.log(e);
          const tit = e.target?.dom?.innerText || '';
          const obj = this.pointsList.find(item => item.examPlaceName === tit);
          console.log('obj: ', obj)
          console.log(tit)
          this.drawerTitle = tit
          // this.getExaminationPlaceById(obj);


          let d = {
            examIdList: [],
            placeId: obj.id
          }
          if (!this.examId) {

            this.examOptions.forEach(item => {
              d.examIdList.push(item.id)
            })
          } else {
            d.examIdList = [this.examId]
          }

          // let d = {
          //   examIdList: [this.examId],
          //   placeId: obj.id
          // }

          this.getExaminationPlaceById(d)
        });

        marker.setMap(map);
        this.markers.push(marker); // 保存到数组中，方便后续清除
      }
    },
    changeExam(v) {
      // this.examId = v;
      console.log('changeExam:', v)
      console.log(this.examId)
      // this.getExaminationPlaceList();

      let data = {
        examIdList: []
      }

      if (v) {
        data.examIdList =
          [
            v
          ]
      } else {
        this.examOptions.forEach(item => {
          data.examIdList.push(item.id)
        })
      }

      console.log('data:', data)
      getExamPlaceList(data).then(res => {
        if (res.data && res.data.length > 0) {
          this.pointsList = res.data;

          // 如果已有地图实例，直接更新点位
          if (this.MAP) {
            this.updateMarkers(this.MAP, res.data);
          }
        } else {
          this.pointsList = [];
          if (this.MAP) {
            this.updateMarkers(this.MAP, []);
          }
        }
      })

    },
    goVideoPage() {
      this.$router.push({
        path: '/video-play'
      })
    },
    goLocationTracePage() {
      this.$router.push({
        path: '/location-trace',
        query: { examId: this.examId }
      });
      // this.$router.push('/location-trace');
    },
    // 获取日期时间
    formatDateTime(date) {
      return (
        date.getFullYear() +
        "-" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + date.getDate()).slice(-2)
      );
    },
    // 进入会议
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }

        this.$emit('submitForm', this.loginForm);
      });
    },

    onOpenSetting() {
      this.$emit('onToggleSetting');
    },
    // 关闭弹窗
    handleClose(done) {
      done();
    },
    // 地图渲染
    mapInit() {
      let zoomVal = '';
      let centerVal = [];
      if (this.isBjShow) {
        this.isBjShow = !this.isBjShow;
        zoomVal = 12;
        centerVal = [116.407702, 39.905114];
      } else {
        this.isBjShow = !this.isBjShow;
        zoomVal = 6;
        centerVal = [113.620251, 34.731161];
      }
      let this_ = this;
      var options = {
        subdistrict: 0,
        extensions: 'all',
        level: 'province'
      };
      var district = new AMap.DistrictSearch(options);
      //查询北京市区域
      district.search('北京市', function (status, result) {
        var bounds = result.districtList[0]['boundaries'];
        var mask = [];
        for (var i = 0; i < bounds.length; i++) {
          mask.push([bounds[i]]);
        }
        //实例化地图
        var map = new AMap.Map('mapContainer', {
          // mask: mask,
          // zoom: 10,                //设置当前显示级别
          // expandZoomRange:true,    //开启显示范围设置
          // zooms: [7, 20],          //最小显示级别为7，最大显示级别为20
          // center: [116.43, 39.92],
          // viewMode: '3D',          //这里特别注意，设置为3D则其它地区不显示
          // zoomEnable: true,        //是否可以缩放地图
          // resizeEnable: true,
          // mapStyle: "amap://styles/light"
          resizeEnable: true,
          // zoom: zoomVal,
          // center: centerVal
          zoom: 10.8, // 北京市
          center: [116.406265, 39.903324], // 北京市
          // zoom: 11, // 朝阳区
          // center: [116.540051,39.941443], // 朝阳区
        });
        //添加描边
        for (var i = 0; i < bounds.length; i++) {
          new AMap.Polyline({
            path: bounds[i],
            // strokeColor:'#11f95a',
            strokeColor: 'red',
            strokeWeight: 5,
            map: map
          })
        }
        // 假设有一个包含点位信息的数组
        // const  points = [
        //   { lng: 116.49, lat: 39.97, title: '标记1' },
        //   { lng: 116.47, lat: 39.92, title: '标记2' },
        //   // ...
        // ]; 
        // const points = this_.pointsList;
        // // 循环遍历所有点位，创建标记并添加到地图上
        // // 创建 AMap.Icon 实例
        // let icon01 = new AMap.Icon({
        //   size: new AMap.Size(46, 46), // 图标尺寸
        //   image: require("../../../assets/addImg/pointsIcon01.png"), // Icon的图像
        //   imageSize: new AMap.Size(46, 46), // 根据所设置的大小拉伸或压缩图片
        //   imageOffset: new AMap.Pixel(0, 0)  // 图像相对展示区域的偏移量，适于雪碧图等
        // }); // 市级图标
        // let icon02 = new AMap.Icon({
        //   size: new AMap.Size(26, 30), // 图标尺寸
        //   image: require("../../../assets/addImg/pointsIcon03.png"), // Icon的图像
        //   imageSize: new AMap.Size(26, 30), // 根据所设置的大小拉伸或压缩图片
        //   imageOffset: new AMap.Pixel(0, 0)  // 图像相对展示区域的偏移量，适于雪碧图等
        // }); // 区级图标
        // let icon03 = new AMap.Icon({
        //   size: new AMap.Size(26, 31), // 图标尺寸
        //   image: require("../../../assets/addImg/pointsIcon02.png"), // Icon的图像
        //   imageSize: new AMap.Size(26, 31), // 根据所设置的大小拉伸或压缩图片
        //   imageOffset: new AMap.Pixel(0, 0)  // 图像相对展示区域的偏移量，适于雪碧图等
        // }); // 考点图标
        // for (var i = 0; i < points.length; i++) {
        //   var point = points[i];
        //   let icons = point.examPlaceType == '市指挥调度中心'?icon01 : point.examPlaceType == '区指挥调度中心'?icon02 : point.examPlaceType == '考点'?icon03:''
        //   var marker = new AMap.Marker({
        //       position: [point.longitude, point.latitude],
        //       // title:'123'
        //       icon: icons, // 添加 Icon 实例
        //   });
        //   marker.setMap(map);
        //   marker.setLabel({
        //     direction: 'center',
        //     offset: new AMap.Pixel(0, -30),  //设置文本标注偏移量
        //     content: point.examPlaceName, //设置文本标注内容
        //   });
        //   // 坐标点点击事件
        //   marker.on('click', (point) => {
        //     console.log(point)
        //       // map.setCenter([lon, lat])
        //       // map.setCenter([point.lnglat.lng, point.lnglat.lat]) // 视图移动到中心
        //       // onclick(eventMark)
        //       let tit = point.target.dom.innerText
        //       let obj = this_.pointsList.find(item => item.examPlaceName === tit);
        //       this_.getExaminationPlaceById(obj);
        //   })
        // }
        // 保存 map 到 this_
        this_.MAP = map;

        // 调用 updateMarkers 方法加载点位
        this_.updateMarkers(map, this_.pointsList);
      });
    },
    // 进入会议
    joinConference(row) {
      let thirdPartyId = sessionStorage.getItem("thirdPartyId");
      let getNums = Math.floor(10000 + Math.random() * 90000);
      if (row.meetingId) {
        this.loginForm.extUserId = thirdPartyId ? thirdPartyId : '20240607';
        this.loginForm.meeting = row.meetingId;
        // this.loginForm.meetingName = 'user_'+getNums;

        let url = window.location.href;

        if (this.currentUserId) {
          this.loginForm.meetingName = 'user_' + this.currentUserId;
        } else {
          let username = decodeURIComponent(url.substring(url.indexOf('?username=') + 10, url.length));
          console.log('username', username)
          if (username) {
            // this.loginForm.meetingName = 'user_'+ username;
            this.loginForm.meetingName = '' + username;
          } else {
            this.loginForm.meetingName = 'user_' + getNums;
          }
        }


        console.log('this.loginForm.username', this.loginForm.username)
        this.$emit('submitForm', this.loginForm);
      }
      console.log('this.loginForm', this.loginForm)
    },
    // 获取考点列表
    getExaminationPlaceList() {
      getExaminationPlaceList({}).then((res) => {
        if (res.code == 200) {
          this.pointsList = res.data;
          this.mapInit();
        }
      })
    },
    // 获取考点信息
    getExaminationPlaceById(row) {

      getExaminationPlaceById({ id: row.placeId }).then((res) => {
        if (res.code == 200) {
          this.drawer = true;
          this.testCenterInfo = res.data;

          getExamDataList(row).then(res2 => {
            if (res.code == 200) {
              // this.drawer = true;
              this.examDataInfo = res2.data;

              // this.examinationDataList = res2.data.examList

            }
          })
        }
      })


    },
    // 获取考试列表
    // getExaminationDataList() {
    //   getExaminationDataList().then(res => {
    //     if (res.code == 200) {
    //       this.examinationDataList = res.data;
    //     }
    //   })
    // },
    idChange() {
      console.log('this.thirdPartyId', this.thirdPartyId)
      if (this.thirdPartyId) {
        sessionStorage.setItem("thirdPartyId", this.thirdPartyId);
        this.curShow = true;
        this.currentUserId = this.thirdPartyId;
        this.$message({
          message: "切换成功！",
          type: 'success',
          center: true,
          offset: 40
        });
        this.thirdPartyId = '';
      }
    },
    // 返回
    goToBack() {
      window.history.back();
    },
    // 定位北京
    goToBj() {
      this.mapInit();
    },
    
    // 切换下拉菜单
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible;
    },

    // 跳转到平台页面
    goToPlatform() {
      this.dropdownVisible = false;
      this.$router.push('/platform');
    },

    // 处理点击外部关闭下拉菜单
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector('.dropdown-menu');
      if (dropdown && !dropdown.contains(event.target)) {
        this.dropdownVisible = false;
      }
    },
  },
  watch: {
    loginForm: {
      handler(newValue) {
        store.set('xy-user', newValue);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
@import './index.scss';

.loginContainer {
  position: relative;
  width: 100%;
  flex: 1;
  margin: 0 auto;
  display: flex;
}

.leftMap {
  width: 100%;
  height: 100%;
}

// .rightMsg{
//   width: 50%;
//   height: 100%;
//   background: rgb(143, 252, 140);
// }
.el-drawer__header {
  margin-bottom: 10px;
}

.testCenter {
  padding: 0 20px;
}

.timer {
  font-size: 16px;
  color: #363636;
}

.numBox {
  display: flex;
  flex-wrap: wrap;
  padding: 20px 0;
  border-bottom: 1px solid #E6E6E6;
}

.numBox p {
  width: 50%;
}

.numBox p span {
  font-size: 18px;
}

.numBox p span.s_1 {
  color: #676767;
}

.numBox p span.s_2 {
  color: #0D8BFF;
}

.tc_Msg {
  padding: 14px 0 4px 0;
  border-bottom: 1px solid #E6E6E6;
}

.tc_Msg li {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}

.tc_Msg li img {
  width: 15px;
  height: 15px;
  margin-right: 10px;
}

.tc_Msg li span.s_1 {
  font-size: 16px;
  color: #666666;
}

.tc_Msg li span.s_2 {
  font-size: 16px;
  color: #363636;
}

.examinationInfo {}

.title_01 {
  font-size: 18px;
  color: #000000;
  font-weight: bold;
  margin: 20px 0;
}

.infoLine {
  border-bottom: 1px dashed #E6E6E6;
  margin-bottom: 20px;
}

.infoLine .title_02 {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}

.infoLine .title_02 img {
  width: 16px;
  height: 17px;
  margin-right: 5px;
}

.infoLine .title_02 span {
  font-size: 18px;
  color: #363636;
}

.lineBox {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.lineBox span {
  font-size: 16px;
  color: #363636;
  width: 50%;
}

.joinBtn {
  height: 40px;
  line-height: 40px;
  background: #0D8BFF;
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
}

.joinBtn:hover {
  opacity: 0.7;
}

.joinBtnTwo {
  background: #eee;
  pointer-events: none;
}

.headerMain {
  display: flex;
  justify-content: space-between;
}

.headerTop {
  font-size: 20px;
  color: #333;
  font-weight: bold;
}

.headerRight {
  display: flex;
}

.changeNums {
  height: 30px;

  input {
    height: 30px;
  }
}

.changeBtn {
  height: 30px;
  margin-left: 10px;
  margin-top: 12px;
}

.curUserInfo {
  font-size: 16px;
  white-space: nowrap;
  margin-right: 10px;
}

.goBack {
  position: absolute;
  left: 10px;
  top: 0;
  font-size: 20px;
  cursor: pointer;
}

.dropdown-menu {
  position: relative;
  margin-left: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;

  .dropdown-arrow {
    width: 14px;
    height: 14px;
    fill: #333333;
    transition: transform 0.3s ease;
    transform: rotate(180deg); // 默认向下
  }

  .arrow-up {
    transform: rotate(0deg); // 展开时向上
  }

  .dropdown-content {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 5px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    min-width: 280px;

    .dropdown-item {
      padding: 8px 12px;
      color: #333333;
      font-size: 14px;
      cursor: pointer;
      white-space: nowrap;
      
      &:hover {
        background-color: #f5f5f5;
      }
    }
  }
}
</style>
